
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";

export class ServiceType extends Resource {
    public override type = 'serviceTypes';

    @prop()
    @required()
    public name!: string;      
}